<template>
  <div class="geo-page">
    <iframe
      :src="iframeSrc"
      frameborder="0"
    />
  </div>
</template>

<script>

import {useRoute} from 'vue-router/dist/vue-router'
import {computed} from 'vue'

export default {
  name: 'OrderManage',
  setup() {
    const route = useRoute()

    const iframeSrc = computed(() => {
      const url = new URL('https://calc.apex-tech.ru/iframe/geo/?color=%23e42c31&location=ebcb9168-70a1-11ed-ae68-ac1f6b447939')
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
.geo-page {
  background-color: #f9f9f9;
}
iframe {
  height: calc(100vh - 92px);
  max-width: 100%;
  width: 100%;
}
@media screen and (max-width: 768px) {

}
</style>
